import { AfterContentInit, ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, fromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { DEFAULT_CAROUSEL_SETTINGS } from '../../../shared/types/CarouselSettings';

@Component({
  selector: 'lp2-industry-content-empty-carousel',
  template: `
    <div class="emptyCarouselContainer">
      <ng-content></ng-content>
      <div class="cardsContainer">
        <lp2-carousel [settings]="carouselSettings">
          <div *ngFor="let card of repeatCards$ | async" class="emptyCard" lp2Slide></div>
        </lp2-carousel>
      </div>
    </div>
  `,
  styleUrls: ['./industry-content-empty-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IndustryContentEmptyCarouselComponent implements OnInit, OnDestroy, AfterContentInit {
  repeatCards$ = new BehaviorSubject(Array(3));
  carouselSettings = {
    ...DEFAULT_CAROUSEL_SETTINGS,
    nav: false,
    stagePadding: 24,
  };

  private subscriptions = new Subscription();

  ngOnInit() {
    this.subscriptions.add(
      fromEvent(window, 'resize')
        .pipe(debounceTime(500))
        .subscribe((event: any) => this.changeNumberOfCards(event.target.innerWidth))
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  ngAfterContentInit() {
    this.changeNumberOfCards(window.innerWidth);
  }

  private changeNumberOfCards(innerWidth: number) {
    if (innerWidth < 525) {
      this.updateRepeatCards(2);
    } else if (innerWidth < 992) {
      this.updateRepeatCards(3);
    } else if (innerWidth < 1200) {
      this.updateRepeatCards(4);
    } else {
      this.updateRepeatCards(5);
    }
  }

  private updateRepeatCards(numberOfCards: number) {
    if (this.repeatCards$.value.length !== numberOfCards) {
      this.repeatCards$.next(new Array(numberOfCards));
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/industry-content-section/industry-content-empty-carousel/industry-content-empty-carousel.component.ts